var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34923 4.24075C8.76855 3.88132 9.39985 3.92989 9.75927 4.34921L15.7593 11.3492C16.0803 11.7237 16.0803 12.2763 15.7593 12.6508L9.75927 19.6508C9.39985 20.0701 8.76855 20.1187 8.34923 19.7593C7.9299 19.3998 7.88134 18.7685 8.24076 18.3492L13.6829 12L8.24076 5.65079C7.88134 5.23147 7.9299 4.60017 8.34923 4.24075Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjM0OTIzIDQuMjQwNzVDOC43Njg1NSAzLjg4MTMyIDkuMzk5ODUgMy45Mjk4OSA5Ljc1OTI3IDQuMzQ5MjFMMTUuNzU5MyAxMS4zNDkyQzE2LjA4MDMgMTEuNzIzNyAxNi4wODAzIDEyLjI3NjMgMTUuNzU5MyAxMi42NTA4TDkuNzU5MjcgMTkuNjUwOEM5LjM5OTg1IDIwLjA3MDEgOC43Njg1NSAyMC4xMTg3IDguMzQ5MjMgMTkuNzU5M0M3LjkyOTkgMTkuMzk5OCA3Ljg4MTM0IDE4Ljc2ODUgOC4yNDA3NiAxOC4zNDkyTDEzLjY4MjkgMTJMOC4yNDA3NiA1LjY1MDc5QzcuODgxMzQgNS4yMzE0NyA3LjkyOTkgNC42MDAxNyA4LjM0OTIzIDQuMjQwNzVaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };